var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{attrs:{"id":_vm.modalName,"title":"Customer is on credit hold","ok-only":"","centered":""},model:{value:(_vm.modalIsVisible),callback:function ($$v) {_vm.modalIsVisible=$$v},expression:"modalIsVisible"}},[_c('p',[_vm._v("This customer is currently on credit hold and cannot be scheduled.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }